import { defineSlotRecipe, defineStyle } from '@chakra-ui/react';

export const radioGroupSlotRecipe = defineSlotRecipe({
  slots: ['root', 'control', 'label', 'item'],
  base: {
    control: defineStyle({
      w: 'var(--checkbox-size)',
      h: 'var(--checkbox-size)',
      transitionProperty: 'box-shadow',
      transitionDuration: 'normal',
      border: '2px solid',
      borderRadius: 'full',
      borderColor: 'inherit',
      color: 'white',
      _checked: {
        bg: 'gray.500',
        borderColor: 'gray.500',
        color: 'white',
        _hover: { bg: 'gray.600', borderColor: 'gray.600' },
        _disabled: {
          borderColor: 'gray.200',
          bg: 'gray.200',
          color: 'gray.500',
        },
        _before: {
          content: '""',
          display: 'inline-block',
          pos: 'relative',
          w: '50%',
          h: '50%',
          borderRadius: '50%',
          bg: 'currentColor',
        },
      },
      _indeterminate: {
        bg: 'gray.500',
        borderColor: 'gray.500',
        color: 'white',
      },
      _disabled: { bg: 'gray.100', borderColor: 'gray.100' },
      _focusVisible: { boxShadow: 'outline' },
      _invalid: { borderColor: 'red.500' },
    }),
    label: defineStyle({
      userSelect: 'none',
      _disabled: { opacity: 0.4 },
    }),
    root: defineStyle({
      '& label': {
        fontSize: 'sm !important',

        '& [data-part="item-text"]': {
          paddingLeft: 2,
        },
      },
    }),
  },
});

export default radioGroupSlotRecipe;
